export enum PlagSeverity {
    Contraindicated = 1,
    NotRecommended = 2,
    ExtremeCaution = 3,
    UseCautiously = 4,
    Informational = 5
}
